module.exports = __webpack_public_path__ + "img/menu_btn.bbe5acac.png";